import React, { useContext } from 'react'
import AppsDropdown from './apps/AppsDropdown'
import UserDropdown from './user/UserDropdown'

import { Application, GlobalNavContext } from '../..'
import { DataService } from '../../dataService'
import styles from './ActionContainer.scss'
import NotificationDropdown from './notification/NotificationDropdown'

export interface ActionContainerProps {
  notificationsVisible: boolean
  currentApp: Application
  dataservice: DataService
  showAccountList: boolean
  showUserInfo: boolean
  showOrgList: boolean
  showAppsDropdown: boolean
  onLogout: (event: React.MouseEvent) => void
}

const ActionContainer = ({
  notificationsVisible,
  currentApp,
  dataservice,
  showOrgList,
  showAccountList,
  showAppsDropdown,
  showUserInfo,
  onLogout
}: ActionContainerProps) => {
  const navContext = useContext(GlobalNavContext)
  const isOwner = navContext.account?.organization?.actions?.length > 0

  return (
    <div className={styles.container}>
      <UserDropdown
        onLogout={onLogout}
        showUserInfo={showUserInfo}
        showAccountList={showAccountList}
        showOrgList={showOrgList}
      />
      {(notificationsVisible && navContext.account) ? (
        <NotificationDropdown dataService={dataservice} />
      ) : null}
      {isOwner && showAppsDropdown && <AppsDropdown currentApp={currentApp} />}
    </div>
  )
}

export default ActionContainer
